module.exports = __webpack_public_path__ + "img/banner.08aa5d0c.png";